import { render, staticRenderFns } from "./PublicAnnouncement.vue?vue&type=template&id=beb79a04&scoped=true&"
import script from "./PublicAnnouncement.vue?vue&type=script&lang=js&"
export * from "./PublicAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb79a04",
  null
  
)

export default component.exports